import React, { useState } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Breadcrumb,
} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { addCmsServiceSection } from "../../../actions/cmsServicePageAction";
import FullPageLoader from "../../../components/FullPageLoader/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

// Schema for yup
const validationSchema = Yup.object().shape({
  heading: Yup.string()
    .min(2, "Heading must have at least 2 characters")
    .max(100, "Heading can't be longer than 100 characters")
    .trim("Spaces are not allowed")
    .required("Heading is required"),

  section_type: Yup.string().trim().required("Section Type field is required"),
  content: Yup.string().required("content field is required"),
});

const AddServiceSection = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [getFile, setFile] = useState("");
  const [uploadImage, setUploadImage] = useState(false);
  const handlePreviewImage = (e, setFieldValue) => {
    if (e.target.files[0].type.split("/")[1]) {
      let imageType = e.target.files[0].type.split("/")[1];
      if (
        imageType === "png" ||
        imageType === "jpg" ||
        imageType === "jpeg" ||
        imageType === "gif" ||
        imageType === "webp"
      ) {
        setFieldValue("image", e.target.files[0]);
        setFile(URL.createObjectURL(e.target.files[0]));
      } else {
        setUploadImage(true);
        e.target.value = null;
      }
    }
  };
  const hideModel = () => {
    setUploadImage(false);
  };
  const onEditorChange = async (event, editor, setFieldValue) => {
    setFieldValue("content", editor.getData());
  };
  return (
    <>
      {uploadImage ? (
        <SweetAlert
          warning
          showCloseButton
          confirmBtnText="OK"
          onConfirm={hideModel}
          confirmBtnBsStyle="danger"
          title="Failed! Please select correct Image Format"
          onCancel={hideModel}
          focusCancelBtn
          customClass="del-sweet-alert "
        >
          Supported files ["png", "jpg", "jpeg", "gif", "webp"]
        </SweetAlert>
      ) : null}
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                {/* <Breadcrumb className="care-md-breadcrumb">
                  <Link className="breadcrumb-item" to="/cms/services">
                    Services
                  </Link>
                  <Breadcrumb.Item active>Add</Breadcrumb.Item>
                </Breadcrumb> */}
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Add Content
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Formik
                          initialValues={{
                            heading: "",
                            heading_sec: "",
                            sub_heading: "",
                            sub_heading_sec: "",
                            content: "",
                            link: "",
                            list: "",
                            list_sec: "",
                            section_type: "",
                            image: "",
                            status: false,
                          }}
                          validationSchema={validationSchema}
                          onSubmit={async (
                            values,
                            { setSubmitting, resetForm }
                          ) => {
                            const formData = new FormData();
                            formData.append("heading", values.heading);
                            formData.append("heading_sec", values.heading_sec);
                            formData.append("sub_heading", values.sub_heading);
                            formData.append(
                              "sub_heading_sec",
                              values.sub_heading_sec
                            );
                            formData.append("content", values.content);
                            formData.append("link", values.link);
                            formData.append("list", values.list);
                            formData.append("list_sec", values.list_sec);
                            formData.append(
                              "section_type",
                              values.section_type
                            );
                            formData.append("status", values.status);
                            formData.append("image", values.image);
                            setLoader(true);
                            // When button submits form and form is in the process of submitting, submit button is disabled
                            setSubmitting(true);
                            let res = await addCmsServiceSection(formData);
                            if (res.data.success) {
                              navigate("/cms/services");
                              toast.success(res.data.message);
                            }
                            setLoader(false);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                          }) => (
                            <Form onSubmit={handleSubmit}>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicHeading"
                              >
                                <Form.Label>
                                  Heading <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="heading"
                                  placeholder="Enter heading"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.heading}
                                />
                                {touched.heading && errors.heading ? (
                                  <span
                                    className={errors.heading ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.heading}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicTagline"
                              >
                                <Form.Label>Second Heading</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="heading_sec"
                                  placeholder="Enter second heading"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.heading_sec}
                                />
                                {touched.heading_sec && errors.heading_sec ? (
                                  <span
                                    className={
                                      errors.heading_sec ? `` : `d-none`
                                    }
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.heading_sec}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicHeading"
                              >
                                <Form.Label>Sub Heading</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="sub_heading"
                                  placeholder="Enter sub heading"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.sub_heading}
                                />
                                {touched.sub_heading && errors.sub_heading ? (
                                  <span
                                    className={
                                      errors.sub_heading ? `` : `d-none`
                                    }
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.sub_heading}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicTagline"
                              >
                                <Form.Label>Second Sub Heading</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="sub_heading_sec"
                                  placeholder="Enter second sub heading"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.sub_heading_sec}
                                />
                                {touched.sub_heading_sec &&
                                errors.sub_heading_sec ? (
                                  <span
                                    className={
                                      errors.sub_heading_sec ? `` : `d-none`
                                    }
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.sub_heading_sec}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicContent"
                              >
                                <Form.Label>
                                  Content <span className="text-danger">*</span>
                                </Form.Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={values.content ? values.content : ""}
                                  content={values.content ? values.content : ""}
                                  onChange={(event, editor) =>
                                    onEditorChange(event, editor, setFieldValue)
                                  }
                                />
                                {touched.content && errors.content ? (
                                  <span
                                    className={errors.content ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.content}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicTagline"
                              >
                                <Form.Label>Link</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="link"
                                  placeholder="Enter link"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.link}
                                />
                                {touched.link && errors.link ? (
                                  <span className={errors.link ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {errors.link}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicTagline"
                              >
                                <Form.Label>List</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="list"
                                  placeholder="Enter list"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.list}
                                />
                                {touched.list && errors.list ? (
                                  <span className={errors.list ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {errors.list}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicTagline"
                              >
                                <Form.Label>Second List</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="list_sec"
                                  placeholder="Enter list second"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.list_sec}
                                />
                                {touched.list_sec && errors.list_sec ? (
                                  <span
                                    className={errors.list_sec ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.list_sec}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicSectionType"
                              >
                                <Form.Label>
                                  Section Display Order
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  name="section_type"
                                  placeholder="Enter Section Display Order"
                                  onChange={(e) => handleChange(e)}
                                />
                                {touched.section_type && errors.section_type ? (
                                  <span
                                    className={
                                      errors.section_type ? `` : `d-none`
                                    }
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.section_type}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                controlId="formFile"
                                className="mb-3"
                                onChange={(e) =>
                                  handlePreviewImage(e, setFieldValue)
                                }
                              >
                                <Form.Label>Upload Image</Form.Label>
                                <Form.Control
                                  type="file"
                                  name="image"
                                  accept=".png,.jpg,.jpeg,.webp"
                                />
                                {touched.image && errors.image ? (
                                  <span
                                    className={errors.image ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.image}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                controlId="formFilePreview"
                                className="mb-3"
                              >
                                {getFile ? (
                                  <img
                                    src={getFile}
                                    width="200"
                                    height="200"
                                    alt="not found"
                                  />
                                ) : null}
                              </Form.Group>
                              <Row>
                                <Col md={1}>
                                  <label className="label-font">Status</label>
                                </Col>
                                <Col
                                  md={11}
                                  className="check-inline d-flex mt-3 flex-column"
                                >
                                  <label className="right-label-radio mr-3 mb-2">
                                    Active
                                    <input
                                      name="status"
                                      className="status"
                                      checked={values.status}
                                      value={values.status}
                                      type="radio"
                                      onChange={(e) =>
                                        setFieldValue("status", true)
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>

                                  <label className="right-label-radio mr-3 mb-2">
                                    Inactive
                                    <input
                                      name="status1"
                                      className="status"
                                      checked={!values.status}
                                      value={!values.status}
                                      type="radio"
                                      onChange={(e) =>
                                        setFieldValue("status", false)
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                </Col>
                              </Row>
                              <Button className="btn-filled" type="submit">
                                Submit
                              </Button>
                            </Form>
                          )}
                        </Formik>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default AddServiceSection;
